import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';

@Injectable({ providedIn: 'root' })
export class ReturnTransactionsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    createReturn(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    getReturnHistories(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<any[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }




    GetReturnTransactionByStockItem(customerId : number, model : any){
        return this.http
        .post<any[]>(this._url(`/Customers/${customerId}/grid-data`), model, {
          observe: 'response'})
        .pipe(map(augmentPaging));
      }

    NumberOfStockItemsReturnedLastXMonths(top: number = 10){
      return this.client.get(this._url(`/NumberOfStockItemsReturnedLastXMonths/${top}`));
    }

    QuantityOfReturnedStockItemsLastXMonths(top: number = 10){
      return this.client.get(this._url(`/QuantityOfReturnedStockItemsLastXMonths/${top}`));
    }

    NumberOfReturnedTransactionLastXMonths(top: number = 10){
      return this.client.get(this._url(`/NumberOfReturnedTransactionLastXMonths/${top}`));
    }

    NumberOfStockItemsReturnedPerCustomer(top: number = 10){
      return this.client.get(this._url(`/NumberOfStockItemsReturnedPerCustomer/${top}`));
    }

    ReturnedPerCategory(top: number = 10){
      return this.client.get(this._url(`/ReturnedPerCategory/${top}`));
    }

    ReturnedPerStockItem(top: number = 10){
      return this.client.get(this._url(`/ReturnedPerStockItem/${top}`));
    }

    ReturnedPerUser(top: number = 10){
      return this.client.get(this._url(`/ReturnedPerUser/${top}`));
    }

    ReturnedPerLocation(top: number = 10){
      return this.client.get(this._url(`/ReturnedPerLocation/${top}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/ReturnTransactions${v}`);
    }
}
